import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import { memo } from "react";

const HelperIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 18 17"
      sx={{
        fontSize: "inherit",
        fill: "none",
        ...sx,
      }}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.62583 13.6H10.3258V11.9H8.62583V13.6ZM9.47583 0C4.78383 0 0.97583 3.808 0.97583 8.5C0.97583 13.192 4.78383 17 9.47583 17C14.1678 17 17.9758 13.192 17.9758 8.5C17.9758 3.808 14.1678 0 9.47583 0ZM9.47583 15.3C5.72733 15.3 2.67583 12.2485 2.67583 8.5C2.67583 4.7515 5.72733 1.7 9.47583 1.7C13.2243 1.7 16.2758 4.7515 16.2758 8.5C16.2758 12.2485 13.2243 15.3 9.47583 15.3ZM9.47583 3.4C7.59733 3.4 6.07583 4.9215 6.07583 6.8H7.77583C7.77583 5.865 8.54083 5.1 9.47583 5.1C10.4108 5.1 11.1758 5.865 11.1758 6.8C11.1758 8.5 8.62583 8.2875 8.62583 11.05H10.3258C10.3258 9.1375 12.8758 8.925 12.8758 6.8C12.8758 4.9215 11.3543 3.4 9.47583 3.4Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
export default memo(HelperIcon);
